module.exports = __webpack_public_path__ + "static/media/dxJy@4x.e84dc2b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dxJy@4x.png
// module id = 1750
// module chunks = 0 1